// extracted by mini-css-extract-plugin
export default {"nameCol":"gSdem8r5O6LDAgtt6c_3","priceCol":"ANg0jnAHVFH3S326c9QV","pricePerItem":"otTd64SM8WcVnPKF0meU","issued":"nMCKBX1ZOyoC7T6ln6Hl","placeHolderShimmer":"oZyfPY2xAdJSyocvmr2k"};